import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const rentalOrderTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "rental.order-trend",
  name: "Rental bookings",
  description: "Rental bookings across the selected period.",
  apps: [
    "rental",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "rental.orders",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "order_id",
          as: "value",
        },
      ],
    },
    graphQueries: [
      {
        name: "Orders",
        query: {
          version: 1,
          source: "rental.orders",
          ...period(30),
          select: [
            {
              type: "field",
              field: "start_at",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "count_distinct",
              field: "order_id",
              as: "value",
            },
          ],
          group_by: [
            {
              field: "start_at",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "area",
        color: "#206bc4",
        lineWidth: 2,
        fillOpacity: 0.16,
        valueMultiplier: 1,
      },
    ],
  },
  inputs: {
    title: "Rental bookings",
    valueFormat: "number",
    valueMultiplier: 1,
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "0",
    series: [
      18,
      24,
      20,
      32,
      29,
      41,
      48,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
